/**
 * @module Banners - Service Check
 * @description Service Check Sticky Banner
 */
import { useContext } from 'react';
import { FuelContext } from '@/providers/fuel-provider';
import PropTypes from 'prop-types';
import ServiceCheckSingleLine from '@/components/blocks/ServiceCheckForm';
import styles from './BannerServiceCheck.module.css';

/**
 * @function Component
 * @description
 */
const Component = ( { ...props } ) => {
  const { phoneHeavy } = useContext( FuelContext );
  const {
    copy = null,
    theme = null
  } = props;

  if ( phoneHeavy === true ) {
    return ( <></> );
  }

  return (
    <section className={ `component ${ styles.component } ${ theme && `u-theme-${ theme }` }` }>
      <div className="l-container">
        <div className={ styles.component__body }>
          <p className={ styles.component__copy }>{ copy }</p>
          <div className={ styles.component__formWrapper }><ServiceCheckSingleLine /></div>
        </div>
      </div>
    </section>
  );
};

Component.propTypes = {
  copy: PropTypes.node,
  theme: PropTypes.string
};

export default Component;
